


















































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { mapGetters } from 'vuex';

import BriocheImageTag from 'frontend/components/BriocheImageTag.vue';
import { MobileGetter } from 'frontend/types';
import { getFeatureList } from 'frontend/views/premium/features';
import { PaywallFeature } from 'frontend/types/premium';

@Component({
  components: {
    BriocheImageTag,
  },
  computed: {
    ...mapGetters('pageHeader', ['isMobile']),
  },
})
export default class PaywallFeatures extends Vue {
  @Prop(Boolean) private readonly onTrialPaywall!: boolean | undefined;
  private isMobile!: MobileGetter;

  private get features(): PaywallFeature[] {
    return getFeatureList();
  }

  private mounted() {
    if (this.isMobile(this.$mq) && this.$refs.paywallFeatures) {
      this.$nextTick(() => ((this.$refs.paywallFeatures as HTMLDivElement).scrollLeft = 10000));
    }
  }
}
